"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const recoil_1 = require("recoil");
const recoil_persist_1 = require("recoil-persist");
const { persistAtom } = (0, recoil_persist_1.recoilPersist)();
exports.default = (0, recoil_1.atom)({
    key: 'mobileProfileState',
    default: {
        profile_img_url: '',
        has_new: false,
    },
    effects_UNSTABLE: [persistAtom],
});
